import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import SFNavbar from './SFComponents/SFNavbar/SFNavbar';
import ContentPanel from '../components/ContentPanel';
import SFAuth from './SFPages/SFAuth/SFAuth';
import { AppProperties } from '../common/functions';
import ESComponentWrapper from '../components/ESComponentWrapper';
import { NotificationContainer } from 'react-notifications';
import SFAnonymousPage from './SFPages/SFAnonymousPage';

class SFApp extends Component {

  appProperties = AppProperties();

  handleSkipToMainContent = (event) => {
    event.preventDefault();
    const mainContent = document.getElementById('quiz-main-content') || document.getElementById('main-content');
    if (mainContent) {
      mainContent.scrollIntoView({ block: 'start' });
      mainContent.focus();
    }
  }

  render() {

    console.debug("this.appProperties.currentUserData", this.appProperties.currentUserData)

    if ((location && location.pathname && location.pathname.includes('/anonymous'))) {
      return <SFAnonymousPage history={this.props.history}></SFAnonymousPage>
    }

    // check if query params has token if so go to SFAuth
    let hasToken = false;
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams) {
      let token = queryParams.get('token');
      if (token !== undefined && token !== null) {
        hasToken = true;
      }
    }
    if (this.appProperties.currentUserData.hasValidData() !== true || hasToken) {

      let LoginPage = ESComponentWrapper(SFAuth);

      return <LoginPage {...this.props} />
    }

    const currentPath = (location?.pathname || '').toLowerCase();
    const isNavbarHidden = currentPath.includes('/takequiz') || currentPath.includes('practicecompleted') || currentPath.includes('testtimerexpired');
    const skipTargetId = currentPath.includes('/takequiz') ? 'quiz-main-content' : 'main-content';

    return (
      <div className='h-100'
        style={{
          background: '#f6f7f8',
          maxWidth: '1920px',
          margin: '0 auto',
        }} >
        {!isNavbarHidden && (
          <a
            href={`#${skipTargetId}`}
            className="sr-only sr-only-focusable position-absolute p-2 bg-white text-dark sf-skip-link"
            onClick={this.handleSkipToMainContent}
          >
            Skip to main content
          </a>
        )}
        {this.appProperties.currentUserData.isAnonymous ? 
          null :
          <SFNavbar {...this.props} />
        }
        <main id="main-content" tabIndex="-1" className="m-0 p-0 h-100">
          <ContentPanel history={this.props.history} className="m-0 p-0 h-100" />
        </main>
        <NotificationContainer />
      </div>
    )
  }
}


export default withRouter(SFApp);
